/// <reference path="../../../../teva/htmlhelpers/htmlhelpers.ts" />

namespace OfficeGuy.Inputs {
    declare var SignaturePad;

    export class Canvas {
        static Init(Container?): void {
            var $Canvases = $("canvas.canvas:not(.canvas-initialized)", Container);
            if ($Canvases.length == 0)
                return;

            $.getScript("/scripts/external/signature_pad.min.js", function () {
                $("canvas.canvas:not(.canvas-initialized)", Container).each(function () {
                    var Canvas = <HTMLCanvasElement>this;
                    var $Canvas = $(Canvas);
                    new SignaturePad(Canvas);
                    var $Image = $Canvas.nextAll("img");
                    if ($Image.length > 0)
                        Canvas.getContext("2d").drawImage(<any>$Image[0], 0, 0);
                    Canvas.addClass("canvas-initialized")
                    $Canvas
                        .after($(document.createElement('a'))
                            .addClass("canvas-trash")
                            .click(function () {
                                var Context = Canvas.getContext('2d');
                                Context.clearRect(0, 0, Canvas.width, Canvas.height);
                            }));
                });
            });
        }
        static Serialize(Container?) {
            $("canvas.canvas", Container).each(function () {
                var Canvas = <HTMLCanvasElement>this;
                var DataURL = Canvas.toDataURL("image/png");
                if (DataURL.indexOf(',') != -1)
                    DataURL = DataURL.substr(DataURL.indexOf(',') + 1);
                $(Canvas).nextAll("input:hidden:first").val(DataURL);
            });
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.Canvas.Init(Container);
});